import { TIMETOKEN_MULTIPLIER } from './message-date-time';

const ONE_SECOND_IN_TIMETOKEN = 1000 * TIMETOKEN_MULTIPLIER;

export const getQueryTypeStarttoken = (thread?: {
  isGrowConversation?: boolean;
  startTimeToken?: string;
  endTimeToken?: string;
}): string | undefined => {
  if (
    !thread?.isGrowConversation ||
    !thread?.startTimeToken ||
    !thread?.endTimeToken
  ) {
    return undefined;
  }

  const parsedGrowStartTimeToken = Number(thread.startTimeToken);
  const parsedGrowEndTimeToken = Number(thread.endTimeToken);

  if (
    Number.isNaN(parsedGrowStartTimeToken) ||
    Number.isNaN(parsedGrowEndTimeToken)
  ) {
    return undefined;
  }

  return String(
    Math.max(parsedGrowStartTimeToken, parsedGrowEndTimeToken) +
      ONE_SECOND_IN_TIMETOKEN
  );
};
